/* eslint-disable */
import ordersEmptyState from '../../assets/images/empty-state-orders.svg'
import sipsEmptyState from '../../assets/images/empty-state-sips.svg'
import investmentsEmptyState from '../../assets/images/empty-state-investments.svg'
import { Button } from '../ui/button'
import { useNavigate } from 'react-router-dom'

export const EMPTY_STATE_ILLUSTRATIONS = {
  orders: ordersEmptyState,
  sips: sipsEmptyState,
  investments: investmentsEmptyState,
  mandates: investmentsEmptyState,
  goals: sipsEmptyState,
  funds: investmentsEmptyState,
  external: ordersEmptyState,
  active: sipsEmptyState,
  completed: sipsEmptyState,
  inProgress: investmentsEmptyState,
  inactive: ordersEmptyState,
  cancelled: ordersEmptyState,
  failed: ordersEmptyState,
}

const SIPsEmpty = ({
  title,
  description,
  mainText,
  page,
  showButton,
  variant = 'sips',
  illustration,
  imageClassName = '',
}) => {
  const navigate = useNavigate()
  const imageSrc = illustration || EMPTY_STATE_ILLUSTRATIONS[variant] || sipsEmptyState

  return (
    <div className='flex flex-col items-center justify-start gap-3 px-4 py-8 text-center sm:py-10'>
      <img
        src={imageSrc}
        className={`h-auto w-[240px] max-w-[68vw] sm:w-[260px] ${imageClassName}`}
        alt=''
        aria-hidden='true'
        draggable='false'
      />

      <div className='max-w-md'>
        <p className='mt-1 mb-1 font-DMSans text-xl font-semibold leading-7 tracking-normal text-black-500'>
          {title}
        </p>

        <p className='mb-3 font-DMSans text-sm font-normal leading-5 text-black-400 sm:text-base sm:leading-6'>
          {description}
        </p>

        {showButton && <Button onClick={() => navigate(page)}>Discover Top Funds </Button>}
      </div>
    </div>
  )
}

export default SIPsEmpty
